export var ACTIONS;
(function (ACTIONS) {
    ACTIONS["AUTH_CAS"] = "AUTH_CAS";
    ACTIONS["OTP_NUMBER"] = "OTP_NUMBER";
    ACTIONS["RESEND_OTP_AUTH_CAS"] = "RESEND_OTP_AUTH_CAS";
    ACTIONS["GO_BACK"] = "GO_BACK";
    ACTIONS["NAV_TO_FETCH"] = "NAV_TO_FETCH";
    ACTIONS["TOGGLE_RADIO"] = "TOGGLE_RADIO";
    ACTIONS["CONFIRM"] = "CONFIRM";
})(ACTIONS || (ACTIONS = {}));
